import React, { useState, useRef, useEffect } from 'react';
import ReactHtmlParser from 'react-html-parser';
import classNames from 'classnames';
import './styles.scss';

const ExpandableContent = ({ htmlContent, title }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isOverflow, setIsOverflow] = useState(false);
    const contentRef = useRef(null);

    useEffect(() => {
        const checkOverflow = () => {
            if (contentRef.current) {
                
                const hasOverflow = contentRef.current.scrollHeight > contentRef.current.clientHeight;
                setIsOverflow(hasOverflow);
            }
        };

        
        checkOverflow();
        
        
        window.addEventListener('resize', checkOverflow);
        return () => window.removeEventListener('resize', checkOverflow);
    }, [htmlContent]);

    if (!htmlContent) return null;

    return (
        <div className="expandable-section mg-t-10">
            {title && <h3 style={{ fontSize: '18px', fontWeight: 'bold' }} className='title-intro'>{title}</h3>}
            
            <div 
                ref={contentRef}
                className={classNames('dessc-2', { 'line-clamp-2': !isExpanded })}
            >
                {ReactHtmlParser(htmlContent)}
                
            </div>

            {isOverflow && (
                <div 
                    className="view-more-btn"
                    style={{ color: 'rgba(0, 138, 251, 1)'}}
                    onClick={(e) => {
                        e.stopPropagation(); 
                        setIsExpanded(!isExpanded);
                    }}
                >
                    {isExpanded ? '表示を減らす' : 'もっと見る'}
                </div>
            )}
        </div>
    );
};

export default ExpandableContent;
